/* eslint-disable arrow-body-style */
/* eslint-disable camelcase */
/* eslint-disable no-plusplus */
/* eslint-disable max-len */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-param-reassign */
import React, {
    useContext,
    useCallback,
    useState,
    useEffect,
    useRef
} from 'react';
import _ from 'lodash';
import { FormattedMessage, useTranslator } from '@jutro/locale';
import { WizardPage, wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm, ViewModelServiceContext } from '@xengage/gw-portals-viewmodel-react';
import { MLPAAgentEditVehicleComponent } from 'ml-components-common-react';
import { MLMultiLobsDataHolderService } from 'ml-services-common-react';
import { MLDriverVehicleUtil, MLNotificationBlockUtil, MLWizardNavUtil } from 'ml-portals-util-react';
import { MLModifierUtil, MLQuoteFlowUtil, MLProductCodeUtil, MLErrorMessageUtil  } from 'ml-portals-util-js';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { UserService } from 'gw-capability-gateway';
import { MLModalService, MLTagManagerService } from 'ml-portals-services-react';
import { platformMessages } from 'ml-components-platform-react';
import { LoadSaveService } from 'gw-capability-gateway-quoteandbind';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import appConfig from 'app-config';
import { MLPortalStorageService } from 'ml-services-common-react';
import { Button } from '@jutro/legacy/components';
import { ScrollToError } from '@jutro/legacy/wizard-next';
import { withRouter } from 'react-router-dom';
import PATrackEvent from 'gw-capability-gateway-quoteandbind-common-react/components/TrackEvent/PATrackEvent';
import metadata from './GatewayVehiclesPage.metadata.json5';
import messages from './GatewayVehiclesPage.messages';
import styles from './GatewayVehiclesPage.module.scss';
import moment from 'moment';

const ACTION_ADD_VEHICLE = 'add';
const ACTION_REMOVE_VEHICLE = 'remove';
const MAX_ALLOWED_YEARS = 2;

function GatewayVehiclesPage(props) {
    const isGPA = appConfig.portalCode === 'GPA';
    const {
        wizardData: submissionVM,
        updateWizardData,
        jumpTo,
        steps,
        goNext,
        updateWizardSnapshot,
        isSkipping,
        currentStep,
        history
    } = props;
    const { onValidate, initialValidation } = useValidation('GatewayVehiclesPage');
    const { authHeader } = useAuthentication();
    const translator = useTranslator();
    const viewModelService = useContext(ViewModelServiceContext);

    const accountHolder = submissionVM.value.getAccountHolderPerson();
    const effectiveDate = _.get(submissionVM, 'baseData.periodStartDate.value', {});
    const policyAddress = _.get(submissionVM, 'baseData.policyAddress.value', {});

    const vehiclesVMPath = 'lobData.personalAuto.coverables.vehicles';
    const paModelVal = _.get(submissionVM, 'lobData.personalAuto.coverables.value', {});
    const vehicleListValue = _.get(submissionVM, `${vehiclesVMPath}.value`, []);
    const vehiclesToDisplay = vehicleListValue.filter((vehicle) => _.isNil(vehicle.namedNonOwner_ML) || vehicle.namedNonOwner_ML === false)

    const VEHICLE_TAB_ID = 'vehicleTab-';
    const [selectedVehicleVM, setSelectedVehicleVM] = useState(undefined);
    const [selectedVehicleIndex, setSelectedVehicleIndex] = useState(0);
    const [activeVehicleTab, setActiveVehicleTab] = useState(`${VEHICLE_TAB_ID}${selectedVehicleIndex}vehiclesIterable`);

    const [stateMissingCommuteError, setStateMissingCommuteError] = useState(false);
    const [stateTrailerError, setStateTrailerError] = useState(false);
    const [stateDuplicateVinError, setStateDuplicateVinError] = useState(false);
    const [stateClassicVehicleAgeError, setStateClassicVehicleAgeError] = useState(false);
    const [stateClassicVehicleAgeErrorMsg, setStateClassicVehicleAgeErrorMsg] = useState(null);
    const [stateAntiqueVehicleAgeError, setStateAntiqueVehicleAgeError] = useState(false);
    const [stateAntiqueVehicleAgeErrorMsg, setStateAntiqueVehicleAgeErrorMsg] = useState(null);
    const [stateRequiredFieldsError, setStateRequiredFieldsError] = useState(false);
    const [stateNewVehicleIndex, setStateNewVehicleIndex] = useState(null);
    const [showErrors, setShowErrors] = useState(false)
    const [alert, setAlert] = useState({});
    const [allVehiclesRemoved, setAllVehiclesRemoved] = useState(false);
    const [errorTimestamp, setErrorTimestamp] = useState(0);
    const [showReturnToQuote, setShowReturnToQuote] = useState(false);
    const quoteStep = steps.find((step) => step.mlStepName === 'quoteDetails');
    const [canRequote, setCanRequote] = useState(false);
    const [stateTrailerorCamperError, setTrailerorCamperError] = useState(false);
    const [stateFarmUseSelectionError, setfarmUseSelectionError] = useState(false);
    const [statefarmUseSelectionWarning, setfarmUseSelectionWarning] = useState(false);
    const [isOnlyStorageVehicles, setIsOnlyStorageVehicles] = useState(false);
    const [stateHasMultipleFarmVehicles, setstateHasMultipleFarmVehicles] = useState(false);
    const hasMultipleFarmVehiclesRef = useRef(false);
    const isModernProduct = _.get(submissionVM, "isModernProduct_Ext.value", false);
    const isModernProductPersonalAuto = isModernProduct && MLProductCodeUtil.isPersonalAuto(_.get(submissionVM, 'baseData.productCode.value'));
    const [vinErrorCheck, updateVinErrorCheck] = useState(undefined);
    const ML_STORAGE_KEY_FARM_SELECTED_VEHICLES = 'FARM_SELECTED_VEHICLES';

    const initialVehicles = _.get(submissionVM, `${vehiclesVMPath}.value`, []).filter((vehicle) => _.isNil(vehicle.namedNonOwner_ML) || vehicle.namedNonOwner_ML === false);
    const [initialVehiclesState, updateInitialVehiclesState] = useState(initialVehicles); // vehicles that were added in Prefill page
    const {
        validateAntiqueVehicleAge,
        validateClassicVehicleAge
    } = MLDriverVehicleUtil();

    const {
        showProgressDialog,
        hideProgressDialog,
        showErrorModal
    } = MLModalService();

     const {
        addErrorAlert,
        clearErrorAlerts
    } = MLNotificationBlockUtil();

    const { returnToQuoteScreen } = MLQuoteFlowUtil();
    const { canShowReturnToQuoteButton } = MLWizardNavUtil(props);

    const getCategoryByCode = (code, vehicle) => {
        return vehicle.category_ML.aspects.availableValues.find((category) => {
            return category.code === code;
        });
    };

    const isCategory = (code, vehicle) => {
        return vehicle.category_ML.value === getCategoryByCode(code, vehicle);
    };

    const isTrailer = (vehicle) => {
        return isCategory('trailer', vehicle);
    };

    const isTrailerNP = (vehicle) => {
        return isCategory('trailer_np', vehicle);
    }

    const isCamper = (vehicle) => {
        return isCategory('camper_np', vehicle);
    }

    const isPrivatePassengerNP = (vehicle) => {
        return isCategory('private_passenger_np', vehicle);
    }

    const initVehicleValue = (vehicle) => {
        if (!vehicle.value_ML || vehicle.value_ML.amount === 0) {
            vehicle.value_ML = {};
        }

        vehicle.tempID = (vehicle.publicID) ? vehicle.publicID : vehicle.tempID;
    };

    const setCanRequoteFlag = useCallback(async () => {
        setCanRequote(showReturnToQuote && _.get(quoteStep, 'visited') !== true);
    }, [quoteStep, showReturnToQuote]);

    useEffect(() => {
        if (isGPA && !isSkipping) {
            UserService.getCurrentUser(authHeader).then((user) => {
                PATrackEvent('Quote Step Reached', isSkipping, submissionVM, user, { step: 'Vehicles Screen', vehiclesToDisplay: vehiclesToDisplay });
            });
        }
        canShowReturnToQuoteButton(submissionVM, authHeader, quoteStep).then((response) => {
            setShowReturnToQuote(!!response);
        });
    }, []);

    // Modifiers
    useEffect(() => {
        setTimeout(() => {
            const vehicleElement = document.getElementsByClassName("jut__TabBar__heading app__GatewayVehiclesPage__tab active")[0];
            if (vehicleElement) {
                vehicleElement.focus();
            } else {
                const noVehicaleElement = document.getElementById("namedNonOwnerContainer");
                if (noVehicaleElement) {
                    noVehicaleElement.focus();
                }
            }
        }, 100)
    }, []);

    useEffect(() => {
        setCanRequoteFlag();
    }, [setCanRequoteFlag, submissionVM]);

    const setEditMode = useCallback((enabled) => {
        // eslint-disable-next-line no-return-assign
        paModelVal.vehicles.forEach((v) => v.editMode_ML = !!enabled);
    }, [paModelVal]);

    const setModifierEditMode = useCallback((editMode) => {
        paModelVal.vehicles.forEach((vehicle) => {
            if (vehicle.vehicleModifiers_ML) {
                vehicle.vehicleModifiers_ML.forEach((mod) => {
                    mod.editMode_ML = editMode;
                });
            }
        });
    }, [paModelVal]);

    const disableValidationForDependentModifiers = useCallback((mod) => {
        if (_.get(mod, 'hasDependentModifier_ML.value')) {
            paModelVal.vehicles.forEach((vehicle) => {
                if (!_.isEmpty(vehicle.vehicleModifiers_ML)) {
                    vehicle.vehicleModifiers_ML.forEach((modifier) => {
                        if (modifier.isDependentModifier_ML) {
                            modifier.editMode_ML = false;
                        }
                    });
                }
            });
        }
    }, [paModelVal]);

    const skipOnResumeIf = useCallback(() => {
        setEditMode(true);
        paModelVal.vehicles.forEach((v) => v.partialVehicleAdditionFlag_Ext = false);

        const jumpToQuote = _.get(history, 'location.state.jumpToQuote', false)
        if (jumpToQuote) {
            return initialValidation().then((isValid) => !!isValid);
        } else {

            if (submissionVM.lobData.personalAuto.coverables.vehicles && (
                submissionVM.lobData.personalAuto.coverables.vehicles.aspects.valid !== true ||
                submissionVM.lobData.personalAuto.coverables.vehicles.aspects.subtreeValid !== true
            )) {
                console.log('Stopping on Vehicles Page becuase vehicles are not valid');

                return false;
            }

            if (currentStep?.mlStepName === 'compPaVehicles') {
                return MLMultiLobsDataHolderService.hasCompletedStep('compPaVehicles');
            }

            if (!!_.get(submissionVM, 'bindData.policyNumber.value')
                && (submissionVM.value.baseData.status_ML === 'Bound' || submissionVM.value.baseData.status_ML === 'Binding')) {
                return true;
            }

            if (MLMultiLobsDataHolderService.getLastVisitedStep() === 'paVehicleDetails') {
                console.log('Stopping on Vehicles PAge because lastVisitedStep is paVehicleDetails');
                return false;
            }

            if (MLMultiLobsDataHolderService.getLastVisitedStep() === 'quoteDetails' &&
                submissionVM.hvqQuoteID_ML.value &&
                submissionVM.isBundle_ML.value) {
                return true;
            }

            if (submissionVM.isBundle_ML.value
                && submissionVM.value.baseData.status_ML !== 'Draft') {
                return true;
            }

            console.log('Skipping Vehicles page because vehicles are valid');
            setEditMode(false);
            return true;
        }
    }, [currentStep?.mlStepName, paModelVal.vehicles, setEditMode, submissionVM]);

    const updateModifiers = useCallback((mod) => {
        if (!isSkipping || (isSkipping && !skipOnResumeIf())) {
            disableValidationForDependentModifiers(mod);
            // Disable validation so we can update the model and the vehicle modifiers with it
            setEditMode(false);
            if (stateNewVehicleIndex) {
                _.set(submissionVM, `value.lobData.personalAuto.coverables.vehicles[${stateNewVehicleIndex}].isCostNewRequired_ML`, false);
            }
            if (currentStep.mlStepName === 'compPaVehicles') {
                _.set(submissionVM, 'bypassValidationForComprater_Ext', true);
            }

            const submissionLoadPromise = LoadSaveService.updateModifiers(submissionVM.value, authHeader);
            showProgressDialog(platformMessages.syncing, submissionLoadPromise, true);
            submissionLoadPromise.then((qdd) => {
                setStateNewVehicleIndex(null);
                const activeVehicleIndex = submissionVM.value.lobData.personalAuto.coverables.vehicles.findIndex((vehicle) => vehicle.active);
                submissionVM.value.lobData.personalAuto.coverables.vehicles.length = 0;
                qdd.lobData.personalAuto.coverables.vehicles.forEach((updatedVehicle, index) => {
                    initVehicleValue(updatedVehicle);
                    if (index === activeVehicleIndex) {
                        updatedVehicle.active = true;
                    }
                    submissionVM.value.lobData.personalAuto.coverables.vehicles.push(updatedVehicle);
                });

            }, (error) => {
                // eslint-disable-next-line no-console
                console.error(error);
            }).finally(() => {
                setEditMode(true);
                setModifierEditMode(true);
                updateWizardData(submissionVM);
            });
            return submissionLoadPromise;
        }
    }, [authHeader, disableValidationForDependentModifiers, isSkipping, setEditMode, setModifierEditMode, showProgressDialog, skipOnResumeIf, stateNewVehicleIndex, submissionVM, updateWizardData]);

    const getVehicleVmAtIndex = useCallback((index) => {
        const vehiclesVM = _.get(submissionVM, vehiclesVMPath, []);
        return vehiclesVM.children[index];
    }, [submissionVM]);

    const addAlert = useCallback((vehicle, message) => {
        setAlert({
            object: (!vehicle?.displayName || vehicle?.displayName === 'null null null') ? 'A Vehicle' : vehicle.displayName,
            message,
            undo: () => {
                // Remove fixedId since deleted vehicles no longer exist in the backend.
                // On undo, treat the vehicle as new using existing data.
                _.unset(vehicle, 'fixedId')
                submissionVM.lobData.personalAuto.coverables.vehicles.pushElement(vehicle);
                updateWizardData(submissionVM);
                setAlert({});
            }
        });
    }, [submissionVM]);

    const removeAlert = () => {
        setAlert({});
    };


    const onRemoveVehicleClick = (vehicle) => {
        MLTagManagerService.sendLinkClickEvent(`${MLTagManagerService.getStepName()}_Remove Vehicle`);
        vehicle.toBeRemoved = true;
        updateWizardData(submissionVM);
    };

    const isValidAtIndex = useCallback((index) => {
        const vm = getVehicleVmAtIndex(index);
        let purchaseYearValid = true
        if(vm?.year?.value && vm?.vehiclePurchaseDate?.year?.value) {
            const minAllowedPurchaseYear = vm.year.value - MAX_ALLOWED_YEARS;
            purchaseYearValid = vm.vehiclePurchaseDate.year.value >= minAllowedPurchaseYear
        }

        if (vm) {
            return vm.aspects.subtreeValid && purchaseYearValid;
        }
        return false;
    }, [getVehicleVmAtIndex]);

    const isModifierSelected = (modifiers, modifierCode) => {
        const modifier = modifiers.find((mod) => mod.codeIdentifier_ML === modifierCode);
        if (modifier) {
            return modifier.chosenTermValue === "true";
        }
        return false;
    };


    const isMissingCommute = () => {
        const notEmployedOccupationCodes = ['unemployed', 'retired', 'student'];
        const employedDrivers = paModelVal.drivers.find((driver) => {
            return driver.occupation_Ext && !notEmployedOccupationCodes.includes(driver.occupation_Ext);
        });
        const commuteVehicles = paModelVal.vehicles.find((vehicle) => {
            return vehicle.primaryUse && (vehicle.primaryUse === 'school_or_work_ml' || vehicle.primaryUse === 'business');
        });

        return !!employedDrivers && !commuteVehicles;
    };

    const trailerValueNull = (vehicle) => {
        if (vehicle.category_ML.value?.code === 'trailer' && _.isUndefined(vehicle.value_ML.amount)) {
            return false;
        }
        return true;
    }
    const primaryUseNull = (vehicle) => {
        if (vehicle.category_ML.value?.code !== 'trailer' && _.isUndefined(vehicle.primaryUse)) {
            return false;
        }
        return true;
    }

    const isAgentLookupVinRequired = (vehicle) => {
        const lookupMessageElm = document.getElementById('agentVinRquiredHelpText');

        if (lookupMessageElm
            && vehicle.value.year
            && vehicle.value.makeCode_ML
            && vehicle.value.modelCode_ML
            && vehicle.value.type_ML
        ) {
            lookupMessageElm.scrollIntoView({
                behavior: "smooth",
                block: "center",
            });
            document.getElementById('agentLookUpVinButton').focus({ preventScroll: true })

            return true;
        }

        return false;
    };

    const handleHasMultipleFarmVehiclesChange = useCallback((hasMultipleFarmVehicles) => {
        hasMultipleFarmVehiclesRef.current = hasMultipleFarmVehicles;
        setstateHasMultipleFarmVehicles(hasMultipleFarmVehicles);
    }, []);

    const isValid = (vehicle) => {
        return vehicle.aspects.valid && vehicle.aspects.subtreeValid && trailerValueNull(vehicle) && primaryUseNull(vehicle) && !shouldShowAltAddressStateError(vehicle.value) && checkValidDate(vehicle.value);
    };

    const isSelectedVehicleValid = () => {
        if (!isValid(selectedVehicleVM)) {
            setShowErrors(true);

            if (isAgentLookupVinRequired(selectedVehicleVM)) {
                return false;
            }

            setErrorTimestamp(errorTimestamp + 1);
            return false;
        }
        return true;
    };

    const checkRequiredFieldsMissing = () => {
        const error = !_.isNil(selectedVehicleVM) && !isValid(selectedVehicleVM)
        setStateRequiredFieldsError(error);
        return error;
    };

    const validate = () => {
        let noOfTrailers = 0;
        let noOfCampers = 0;
        let noofTrailersNP = 0;
        let vehicleStorageUse = 0;
        let noOfPrivatePassengerNP = 0;
        const vins = [];
        let ignoreCommuteWarning = false;
        let classicVehicleAgeError = {};
        let antiqueVehicleAgeError = {};

        if (stateMissingCommuteError || isModernProduct) {
            ignoreCommuteWarning = true;
        }

        const allVehicles = _.get(submissionVM, `${vehiclesVMPath}.children`, []);
        allVehicles.forEach((vehicle) => {
            const vehiclePrimaryUse = vehicle?.primaryUse?.value?.code;
            if (isTrailer(vehicle)) {
                noOfTrailers++;
            }

            if(isTrailerNP(vehicle)) {
                noofTrailersNP++;
            }

            if(isCamper(vehicle)){
                noOfCampers++;
            }

            if(isPrivatePassengerNP(vehicle)){
                noOfPrivatePassengerNP++;
            }

            if(vehiclePrimaryUse === 'storage_np'){
                vehicleStorageUse++;
            }

            if (!_.isNil(vehicle.vin.value)) {
                vins.push(vehicle.vin.value);
            }

            const objAntique = validateAntiqueVehicleAge(vehicle, effectiveDate);
            if (objAntique.hasError) {
                antiqueVehicleAgeError = objAntique;
            }

            const objClassic = validateClassicVehicleAge(vehicle, effectiveDate);
            if (objClassic.hasError) {
                classicVehicleAgeError = objClassic;
            }
        });

        const trailerError = noOfTrailers > 0 && noOfTrailers === vehicleListValue.length && !isModernProductPersonalAuto;
        const noOfTrailersAndCampers = noOfCampers + noofTrailersNP;
        const trailerorCamperError = isModernProductPersonalAuto && (noOfTrailersAndCampers > 0 && noOfTrailersAndCampers === vehicleListValue.length);
        const duplicateVinError = vins.length !== new Set(vins).size;
        const missingCommuteError = ignoreCommuteWarning ? false : isMissingCommute();
        const hasMultipleFarmVehicles = hasMultipleFarmVehiclesRef.current;

        setStateClassicVehicleAgeError(classicVehicleAgeError.hasError);
        const classicVehicleAgeErrorMsg = classicVehicleAgeError.errorMessage;
        setStateAntiqueVehicleAgeError(antiqueVehicleAgeError.hasError);
        const antiqueVehicleAgeErrorMsg = antiqueVehicleAgeError.errorMessage;
        const requiredFieldsError = checkRequiredFieldsMissing();

        const vehicleOnlyStorageError = vehicleStorageUse > 0 && vehicleStorageUse === noOfPrivatePassengerNP && isModernProductPersonalAuto;

        const hasVinError = () => {
            return !!vinErrorCheck
        }

        if (missingCommuteError || duplicateVinError || trailerError || trailerorCamperError || vehicleOnlyStorageError
            || classicVehicleAgeError || antiqueVehicleAgeError || requiredFieldsError || hasVinError()) {
            window.scrollTo(0, 0);
        }

        const valid = !trailerError && !duplicateVinError && !missingCommuteError && !trailerorCamperError && !vehicleOnlyStorageError
            && !classicVehicleAgeError.hasError && !antiqueVehicleAgeError.hasError && !requiredFieldsError && !hasVinError() && !hasMultipleFarmVehicles;

        setStateTrailerError(trailerError);
        setTrailerorCamperError(trailerorCamperError);
        setStateDuplicateVinError(duplicateVinError);
        setStateMissingCommuteError(missingCommuteError);
        setStateClassicVehicleAgeErrorMsg(classicVehicleAgeErrorMsg);
        setStateAntiqueVehicleAgeErrorMsg(antiqueVehicleAgeErrorMsg);
        setIsOnlyStorageVehicles(vehicleOnlyStorageError);

        let firstPurchaseDateErrVehicle = ''
        const purchaseYearInValid = allVehicles.some((vm)=>{
            if(vm?.year?.value && vm?.vehiclePurchaseDate?.year?.value) {
                const minAllowedPurchaseYear = vm.year.value - MAX_ALLOWED_YEARS;
                if(vm.vehiclePurchaseDate.year.value < minAllowedPurchaseYear){
                    if(firstPurchaseDateErrVehicle.length === 0) {
                        firstPurchaseDateErrVehicle = vm.displayName.value
                    }
                    return true
                }
            }
            return false
        })
        if(purchaseYearInValid){
            hideProgressDialog();
            const isPurchaseYearWithinTwoYearsPriorErrorNP = translator(messages.maxTwoYearsAllowedForPurchaseYearNP, {
                vehicleName: firstPurchaseDateErrVehicle
            });
            setAlert({
                message: isPurchaseYearWithinTwoYearsPriorErrorNP,
                type: 'error',
                undo: () => {
                    setAlert({});
                }
            });
            return;
        }

        return valid;
    };

    const cleanNonOwnedVehicles = useCallback(() => {
        const namedNonOwnerVehs = paModelVal.vehicles.filter((veh) => veh.namedNonOwner_ML === true);
        if (namedNonOwnerVehs.length > 0) {
            namedNonOwnerVehs.forEach((nonOwnerVeh) => {
                paModelVal?.removeVehicle(nonOwnerVeh);
            });
        }
    }, [paModelVal]);

    const addNewVehicle = useCallback(() => {
        const newVehicle = paModelVal?.createVehicle(accountHolder);
        newVehicle.editMode_ML = true;
        cleanNonOwnedVehicles();
    }, [accountHolder, cleanNonOwnedVehicles, paModelVal]);

    const onVehicleTabChange = useCallback((tabId) => {
        let vehicleIndex;

        if (tabId === 'addVehicleTabButton') { // Add Vehicle
            addNewVehicle();
            vehicleIndex = paModelVal.vehicles?.length - 1;
            const newTabString = `${VEHICLE_TAB_ID}${vehicleIndex}vehiclesIterable`;
            setActiveVehicleTab(newTabString);
            setStateNewVehicleIndex(vehicleIndex);
            removeAlert();
            MLTagManagerService.sendLinkClickEvent(`${MLTagManagerService.getStepName()}_Add Vehicle`);
        } else {
            const indexOfNumber = tabId.indexOf('-') + 1;

            vehicleIndex = Number(tabId.substring(indexOfNumber, tabId.indexOf('vehiclesIterable')));

            const currentVehicleVal = paModelVal.vehicles[vehicleIndex];

            if (currentVehicleVal.toBeRemoved === true) { // Remove Vehicle
                paModelVal?.removeVehicle(currentVehicleVal);

                const idx = _.indexOf(initialVehiclesState, currentVehicleVal);
                if (idx >= 0) {
                    initialVehiclesState.splice(idx, 1);
                }
                currentVehicleVal.toBeRemoved = false;
                if (vehicleIndex !== 0) {
                    const newIndex = vehicleIndex - 1;
                    vehicleIndex = newIndex;
                }
                if (vehicleListValue.length === 0) {
                    setAllVehiclesRemoved(true);
                }
                const newTabString = `${VEHICLE_TAB_ID}${vehicleIndex}vehiclesIterable`;
                setActiveVehicleTab(newTabString);
                addAlert(currentVehicleVal, translator(messages.hasBeenRemoved));

                // Need to save when deleting vehicle to prevent 'failed to update batch' errors
                setEditMode(false); //Do not want to validate b/c some vehicles may not be valid
                _.set(submissionVM, 'portalCurrentStep_ML.value', ''); // Do not want to trigger IMF

                const newSubmissionVM = viewModelService.clone(submissionVM);
                const promise = LoadSaveService.updateDraftSubmission(newSubmissionVM.value, authHeader);

                showProgressDialog(platformMessages.saveSubmission, promise);
                promise.then((res) => {
                    _.set(newSubmissionVM, 'value', res);                    
                    const newPaModelVal = _.get(newSubmissionVM, 'lobData.personalAuto.coverables.value', {});
                    newPaModelVal.vehicles.forEach((v) => v.editMode_ML = true);                 
                    updateWizardData(newSubmissionVM);  
                }).finally(() => {
                    setEditMode(true);
                    updateWizardSnapshot(newSubmissionVM);
                });
            } else {
                setActiveVehicleTab(tabId); // Change Tab
                removeAlert();
            }
        }
        const vehicleVM = getVehicleVmAtIndex(vehicleIndex);

        if (vehicleVM === selectedVehicleVM) {
            return;
        }
        setSelectedVehicleVM(vehicleVM);
        setSelectedVehicleIndex(vehicleIndex);
    }, [addAlert, addNewVehicle, getVehicleVmAtIndex, paModelVal, selectedVehicleVM, translator]);

    const switchToTabWithErrors = () => {
        const activeTabIsValid = selectedVehicleVM?.aspects.subtreeValid;
        if (activeTabIsValid) {
            const allVehicles = _.get(submissionVM, `${vehiclesVMPath}.children`, []);
            const invalidIndex = allVehicles.findIndex((v) => !isValid(v));
            if (invalidIndex !== -1) {
                const newTabString = `${VEHICLE_TAB_ID}${invalidIndex}vehiclesIterable`;
                setActiveVehicleTab(newTabString);
                removeAlert();
                const vehicleVM = getVehicleVmAtIndex(invalidIndex);
                if (vehicleVM === selectedVehicleVM) {
                    return;
                }
                setSelectedVehicleVM(vehicleVM);
                setSelectedVehicleIndex(invalidIndex);
                return true;
            }
        }
        return false;
    };

    const createNamedNonOwnerAndNextAction = () => {
        if (!paModelVal?.hasNamedNonOwner()) {
            const namedNonOwnerVehicle = paModelVal?.createVehicle(accountHolder);
            namedNonOwnerVehicle.namedNonOwner_ML = true;
            namedNonOwnerVehicle.costNew = {
                amount: 0
            };
            namedNonOwnerVehicle.additionalInterests_ML = [];
        }
    };

    const isNamedNonOwner = () => {
        return vehicleListValue.length === 0 || vehicleListValue.some((vehicle) => {
            return vehicle.namedNonOwner_ML === true;
        });
    };

    const validateData = useCallback((isReturnToQuote = false) => {
        _.set(submissionVM, 'portalCurrentStep_ML.value', currentStep.mlStepName);

        setShowErrors(false);
        if (!isNamedNonOwner() && !isSelectedVehicleValid()) {
            return false;
        }

        if (_.get(paModelVal, 'vehicles.length') > 0 && !paModelVal?.hasNamedNonOwner()) {
            const wasSwitched = switchToTabWithErrors();
            if (!validate() || wasSwitched) {

                // Delay this a bit to allow tab to change before showing errors
                setTimeout(() => {
                    setShowErrors(true);
                    setErrorTimestamp(errorTimestamp + 1);
                }, 200);
                return false;
            }
        } else {
            createNamedNonOwnerAndNextAction();
        }

        if (isReturnToQuote) {
            MLMultiLobsDataHolderService.storeFlowSteps(currentStep.mlStepName, 'quoteDetails', authHeader);
        }

        return true;
    }, [authHeader, createNamedNonOwnerAndNextAction, currentStep.mlStepName, errorTimestamp, isNamedNonOwner, isSelectedVehicleValid, paModelVal, switchToTabWithErrors, validate]);

    const returnToQuoteFunction = useCallback(async () => {
        await returnToQuoteScreen(validateData, submissionVM, updateWizardData, history, authHeader);
    }, [authHeader, history, returnToQuoteScreen, submissionVM, updateWizardData, validateData]);

    const onNext = async () => {
        const nextStepName = (currentStep.mlStepName === 'compPaVehicles') ? 'compPaValidateInfo' : 'paAddtlInfoToQuote';
        const canSkipSave = steps.some((step) => step.mlStepName === nextStepName && !!step.visited);

        if (isGPA) {
            UserService.getCurrentUser(authHeader).then((user) => {
                PATrackEvent('Quote Step Submitted', false, submissionVM, user, { step: 'Vehicles Screen', action: 'Vehicles Submitted', vehiclesToDisplay: vehiclesToDisplay });
            })
        }

        const isDataValid = await validateData();
        if (!isDataValid) {
            return false;
        }

        // save and move to next page
        if (!submissionVM.value.isQuoted()) {
            _.unset(submissionVM.value, 'bindData');
        }
        _.set(submissionVM, 'portalCurrentStep_ML.value', currentStep.mlStepName);
        const newSubmissionVM = viewModelService.clone(submissionVM);

        if (currentStep.mlStepName === 'compPaVehicles') {
            _.set(newSubmissionVM, 'bypassValidationForComprater_Ext', true);
        }

        if (canSkipSave) {
            MLMultiLobsDataHolderService.storeFlowSteps(currentStep.mlStepName, nextStepName, authHeader);
            goNext();
        } else {
            const promise = LoadSaveService.updateDraftSubmission(newSubmissionVM.value, authHeader);
            showProgressDialog(platformMessages.saveSubmission, promise);
            promise.then((res) => {
                clearErrorAlerts('costNewValidation')
                if(_.has(res, 'proxySymbolsUsed_Ext') && res?.proxySymbolsUsed_Ext === true && !res.costNew?.amount) {
                    hideProgressDialog();
                    addErrorAlert(messages.costNewRequired, 'costNewValidation');
                    return;
                }
                _.set(newSubmissionVM, 'value', res);
                updateWizardData(newSubmissionVM);
                MLMultiLobsDataHolderService.storeFlowSteps(currentStep.mlStepName, nextStepName, authHeader);
                updateWizardSnapshot(newSubmissionVM);
                goNext();
            }).catch((error) => {                
                hideProgressDialog();
                MLErrorMessageUtil.handleException(error, showErrorModal, messages.somethingWentWrong);                
            })
        }
    };

    const checkOwnedLessThanSixMonths = (vehicleVM) => {
        if (!vehicleVM.purchaseDate_ML) {
            vehicleVM.ownedLessThan6Months_Ext = false;
            return;
        }

        const effectiveMonth = effectiveDate.month + 1;
        const currentYear = new Date().getFullYear();

        if (vehicleVM.purchaseDate_ML.year === currentYear - 1) {
            if (effectiveMonth < 6) {
                vehicleVM.ownedLessThan6Months_Ext = true;
            } else {
                vehicleVM.ownedLessThan6Months_Ext = false;
            }
        } else if (vehicleVM.purchaseDate_ML.year === currentYear) {
            if (effectiveMonth > 6) {
                vehicleVM.ownedLessThan6Months_Ext = true;
            } else {
                vehicleVM.ownedLessThan6Months_Ext = true;
            }
        } else {
            vehicleVM.ownedLessThan6Months_Ext = false;
        }
    };

    useEffect(() => {
        const vehicleLists = _.get(submissionVM, `${vehiclesVMPath}.value`, []);
        vehicleLists.forEach((vehicle) => checkOwnedLessThanSixMonths(vehicle));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        const allVehicles = _.get(submissionVM, `${vehiclesVMPath}.children`, []);
        allVehicles.forEach((vehicle) => {
            if (!_.isUndefined(vehicle?.partialVehicleAdditionFlag_Ext?.value) && vehicle?.partialVehicleAdditionFlag_Ext?.value === true) {
                vehicle.partialVehicleAdditionFlag_Ext.value = false;
            }
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        const activeVehicleNumberViaEdit = _.get(submissionVM, 'value.wizardActionDataML.model.vehicleNumber_ML');
        if (!_.isUndefined(activeVehicleNumberViaEdit)) {
            const activeVehicleIndex = activeVehicleNumberViaEdit - 1;
            const tabString = `${VEHICLE_TAB_ID}${activeVehicleIndex}vehiclesIterable`;
            const vehicleVM = getVehicleVmAtIndex(activeVehicleIndex);
            setSelectedVehicleVM(vehicleVM);
            setSelectedVehicleIndex(activeVehicleIndex);
            setActiveVehicleTab(tabString);
        }
        if (_.isUndefined(selectedVehicleVM)) {
            const firstVehicleVM = _.get(submissionVM, `${vehiclesVMPath}.children[0]`);
            if (firstVehicleVM) {
                setSelectedVehicleVM(firstVehicleVM);
            }
        }

        setEditMode(true);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // Redirect Function
    const handleStepAction = (redirectAction) => {
        if (!_.isEmpty(redirectAction)) {
            if (redirectAction.action === ACTION_ADD_VEHICLE) {
                const addID = 'addVehicleTabButton';
                onVehicleTabChange(addID);
            } else if (redirectAction.action === ACTION_REMOVE_VEHICLE) {
                const index = redirectAction.vehicleIndex;
                const vehicleToRemove = paModelVal.vehicles[index];
                if (vehicleToRemove) {
                    vehicleToRemove.toBeRemoved = true;
                    const tabToRemoveID = `vehicleTab-${index}`;
                    onVehicleTabChange(tabToRemoveID);
                }
            }
        }
    };

    useEffect(() => {
        const stepDataML = _.get(submissionVM, 'value.wizardActionDataML', {});
        if (!_.isEmpty(stepDataML)) {
            handleStepAction(stepDataML);
            _.set(submissionVM, 'value.wizardActionDataML', {});
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // End Redirect Functions

    useEffect(() => {
        if (vehicleListValue.length === 0 && allVehiclesRemoved) {
            const idx = steps.findIndex((step) => step.id === 'GatewayPrefillPage');
            jumpTo(idx);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [allVehiclesRemoved, vehicleListValue]);

    const getTabHeader = useCallback((vehicle, index) => {
        return (
            <div className={styles.tabHeading}>
                <div className="ml-flex-tabs__icon">
                    <span className="icon-ml-car-icon" />
                </div>
                <div className="ml-flex-tabs__text">
                    <span className="ml-flex-tabs__text-header">
                        {vehicle.year}
                        {' '}
                        {vehicle.make}
                    </span>
                    <span className="ml-flex-tabs__text-subtext">
                        {vehicle.model}
                        {' '}
                        {vehicle.trim_ML}
                    </span>
                </div>
                {!isValidAtIndex(index) && (
                    <div className="ml-flex-tabs__error">
                        <span className="icon-ml-alert-icon" />
                    </div>
                )}
                <div className="ml-flex-tabs__remove">
                    <span onClick={() => onRemoveVehicleClick(vehicle)} className="icon-ml-remove-icon" />
                </div>
            </div>
        );
    }, [isValidAtIndex]);

    const getAddVehicleTabHeading = useCallback(() => {
        return (
            <Button type="outlined">
                {translator(messages.addVehicleButton)}
            </Button>
        );
    }, [translator]);


    const getNextStepText = (isSticky) => {
        const allVehicles = _.get(submissionVM, `${vehiclesVMPath}.children`, []);
        const hasInvalidVehicles = allVehicles.some((v) => !v.aspects.subtreeValid);
        const isLastIndex = selectedVehicleIndex + 1 === paModelVal.vehicles?.length;
        let formattedMessage;

        if ((isSticky && hasInvalidVehicles) || (!isSticky && !isLastIndex)) {
            formattedMessage = (
                <FormattedMessage
                    {...messages.nextVehicles}
                    values={{
                        addlVehicles: (
                            <strong>{translator(messages.additionalVehicles)}</strong>
                        )
                    }}
                />
            );
        } else if (currentStep.mlStepName === 'compPaVehicles') {
            formattedMessage = (
                <FormattedMessage
                    {...messages.validationNext}
                    values={{
                        validate: (
                            <strong>{translator(messages.validate)}</strong>
                        )
                    }}
                />
            );
        } else {
            formattedMessage = (
                <FormattedMessage
                    {...messages.nextGatherAdditionalInfo}
                    values={{
                        addlInfo: (
                            <strong>{translator(messages.additionalInformation)}</strong>
                        )
                    }}
                />
            );
        }

        return formattedMessage;
    };

    const vehicleAddedFromTab = (vehicle) => {
        return initialVehiclesState.findIndex((initVeh) => { return initVeh.publicID === vehicle.publicID; }) < 0
    }

    const shouldShowAltAddressStateError = (vehicle) => {
        const garagingLocationState = _.get(vehicle, 'garagingLocation_ML.state');
        if (!!garagingLocationState && garagingLocationState !== policyAddress.state) {
            return true;
        }

        return false;
    };

    //Checks if the entered purchased date is valid
    const checkValidDate = (vehicle) => {
        if(!isModernProductPersonalAuto || vehicle?.category_ML !== 'private_passenger_np'){
            return true
        }
        const vPurchaseDate = vehicle.vehiclePurchaseDate;
        var isValidDate = true;
        if (!vPurchaseDate?.day || !vPurchaseDate?.month || !vPurchaseDate?.year) { return false; }
        const selected = new Date(vPurchaseDate?.year, vPurchaseDate?.month - 1, vPurchaseDate?.day);
        const today = new Date();
        const maxDate = new Date();
        maxDate.setDate(today.getDate() + 7);
        if (selected > maxDate) {
            return isValidDate = false;
        }
        const validDate = moment(
            { year: vPurchaseDate.year, month: vPurchaseDate.month - 1, day: vPurchaseDate.day },
            true).isValid();
        if (!validDate) return false;
        return isValidDate;
    }

    const generateVehiclesOverrides = () => {
        const vehicleOverrides = vehiclesToDisplay.map((vehicle, index) => {
            return {
                [`${VEHICLE_TAB_ID}${index}`]: { heading: getTabHeader(vehicle, index) },
                [`trailerErrorDiv${index}`]: {
                    visible: stateTrailerError
                },
                [`trailerorCamperErrorDiv${index}`]: {
                    visible: stateTrailerorCamperError
                },
                [`duplicateVinErrorDiv${index}`]: {
                    visible: stateDuplicateVinError
                },
                [`fixErrorBeforeContinueDIV${index}`]: {
                    visible: stateRequiredFieldsError && showErrors
                },
                [`classicVehicleAgeErrorDiv${index}`]: {
                    visible: !!stateClassicVehicleAgeError
                },
                [`classicVehicleAgeErrorStrong${index}`]: {
                    content: stateClassicVehicleAgeErrorMsg
                },
                [`antiqueVehicleAgeErrorDiv${index}`]: {
                    visible: !!stateAntiqueVehicleAgeError
                },
                [`antiqueVehicleAgeErrorStrong${index}`]: {
                    content: stateAntiqueVehicleAgeErrorMsg
                },
                [`missingCommuteErrorDiv${index}`]: {
                    visible: stateMissingCommuteError
                },
                [`missingCommuteErrorStrong${index}`]: {
                    visible: !isModernProduct
                },
                [`vehicleComponent${index}`]: {
                    vehicleVM: getVehicleVmAtIndex(index),
                    submissionVM,
                    updateModifiers,
                    showValidationErrors: showErrors,
                    isCompRaterQuote: !!submissionVM.hvqQuoteID_ML.value,
                    onValidate,
                    onVehicleValidityChange: checkRequiredFieldsMissing,
                    isNewVehicleTab: vehicleAddedFromTab(vehicle),
                    viewModelService,
                    updateWizardData,
                    purchaseDateInputError: checkValidDate(vehicle),
                    showAltAddressStateError: shouldShowAltAddressStateError(vehicle),
                    updateViewModel: () => updateWizardData(submissionVM),
                    updateVinErrorCheck,
                    vinErrorCheck,
                    onHasMultipleFarmVehiclesChange: handleHasMultipleFarmVehiclesChange,
                    hasMultipleFarmVehicles: stateHasMultipleFarmVehicles
                },
                [`alert${index}`]: {
                    visible: !_.isEmpty(alert),
                    className: `ml-alert ${
                        alert.type === 'error'
                            ? 'ml-alert-error'
                            : 'ml-alert-success'
                    } alert`
                },
                [`alertMessage${index}`]: {
                    content: <FormattedMessage
                        {...messages.alertMessage}
                        values={{
                            object: (
                                <strong>{alert.object}</strong>
                            ),
                            message: translator(alert.message)
                        }}
                    />
                },
                [`alertTooltip${index}`]: {
                    visible: !_.isEmpty(alert.helpText)
                },
                [`undo${index}`]: {
                    onClick: alert.undo
                },
                [`vehicleUseStorageError${index}`]: {
                    visible: isOnlyStorageVehicles
                },
            };
        });
        return Object.assign({}, ...vehicleOverrides);
    };

    const overrideProps = {
        vehiclesIterable: {
            data: vehiclesToDisplay,
            activeTab: activeVehicleTab,
            defaultActiveTab: `${VEHICLE_TAB_ID}${selectedVehicleIndex}vehiclesIterable`
        },
        addVehicleTabButton: {
            heading: getAddVehicleTabHeading()
        },
        namedNonOwnerRow: {
            visible: isNamedNonOwner()
        },
        stickyfootercomponent: {
            defaultContinueSectionId: 'footer',
            nextDescription: getNextStepText(true),
            onNext,
            showReturnToQuote,
            canRequote,
            returnToQuoteFunction
        },
        nextDescription: {
            content: getNextStepText(false)
        },
        returnToQuoteButton: {
            visible: showReturnToQuote,
            disabled: !canRequote,
            onClick: returnToQuoteFunction
        },
        ...generateVehiclesOverrides()
    };

    const resolvers = {
        resolveCallbackMap: {
            onNext,
            onValidate,
            onVehicleTabChange
        },
        resolveClassNameMap: styles,
        resolveComponentMap: {
            mlpaagenteditvehiclecomponent: MLPAAgentEditVehicleComponent
        }
    };

    const readValue = (id, path) => {
        return readViewModelValue(metadata.pageContent, submissionVM, id, path, overrideProps);
    };

    return (
        <WizardPage
            showCancel={false}
            showPrevious={false}
            showNext={false}
            skipWhen={skipOnResumeIf}
            showReturnToQuote={false}
            disableReturnToQuote={!canRequote}
            updateWizardData={updateWizardData}
            history={history}
            validateData={validateData}
        >
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={submissionVM}
                onModelChange={updateWizardData}
                overrideProps={overrideProps}
                onValidationChange={onValidate}
                resolveValue={readValue}
                callbackMap={resolvers.resolveCallbackMap}
                classNameMap={resolvers.resolveClassNameMap}
                componentMap={resolvers.resolveComponentMap}
            />
            <ScrollToError counter={errorTimestamp} />
        </WizardPage>
    );
}

GatewayVehiclesPage.propTypes = wizardProps;
export default withRouter(GatewayVehiclesPage);
